import React from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { YEAR_MONTH_DAY, DAY_MONTH_YEAR } from "constants/date";

import { InputText } from "components/CommonUI";

export default function ReactDatePicker(props) {
  const onChangeDate = (value) =>
    props.onChange && props.onChange(moment(value).format(props.dateFormat ? props.dateFormat : YEAR_MONTH_DAY));

  const ExampleCustomInput = React.forwardRef(({ value, onClick }, ref) => (
    // <button className="example-custom-input" onClick={onClick} ref={ref}>
    //   {value}
    // </button>
    <InputText
      value={moment(value, "MM/DD/YYYY").format(DAY_MONTH_YEAR)}
      // value={value}
      onClick={onClick}
      ref={ref}
      readOnly={true}
      // icon="icon-general-calendar-default"
      // iconStyle={{ cursor: "pointer" }}
      // iconOnClick={onClick}
      iconComponent={
        <span
          class="suffix"
          style={{ position: "absolute", right: 14, color: "rgb(10, 97, 96)" }}
          onClick={onClick}
        >
          <i class="icon icon-dls-calendar" aria-hidden="true"></i>
        </span>
      }
    />
  ));

  return (
    <div className={props.className}>
      <Form.Group>
        <Form.Label>{props.label}</Form.Label>
        <DatePicker
          selected={new Date(props.value)}
          onChange={onChangeDate}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          // includeDates={[new Date(), ...props.includeDates]}
          includeDates={props.includeDates}
          customInput={<ExampleCustomInput />}
          // dateFormat={DAY_MONTH_YEAR}
        />
      </Form.Group>
    </div>
  );
}
